// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditorMediaText {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  text-overflow: clip;\n  text-overflow: ellipsis;\n  text-overflow: \"...\";\n}\n\n.EditorTextContextMenu {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\np {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.4;\n}", ""]);
// Exports
module.exports = exports;
